import { flushSync } from 'react-dom';

/** Mount the clip-card player during the user's click, then play. Remotion
 *  autoPlay after a setState mount loses the gesture, so AudioContext.resume()
 *  never resolves and the clock stays at 0:00. Playing from this same click
 *  keeps the gesture and starts with audio. */
export function startClipCardPlayback(mount: () => void, play: () => void): void {
  flushSync(mount);
  play();
}
